import React, { useState, useEffect } from "react";

import { useForm } from "../../../shared/useForm";
import { Toast } from "../../../shared/toaster/Toaster";

// import { Button, Modal } from 'react-bootstrap';

import docsImg from "../../../assests/images/doc.png";

import "react-toastify/dist/ReactToastify.css";
import InitialModal from "./InitialModal";

function SpecialInstrucModal({
  closeModal,
  cartItemData,
  cardData,
  cartDetails,
}) {
  const [showTextbox, setshowTextbox] = useState("yes");

  const [terms, setSelectedTime] = useState(false);
  const [showError, setError] = useState(false);
  // const [liabilityDocBtn, setliabilityDocBtn] = useState([]);

  // intial modal
  const [passwordModal, setPasswordModal] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });

  console.log({
    closeModal,
    cartItemData,
    cardData,
    cartDetails,
  });
  const { values, errors, bindField, setInitialValues } = useForm({
    validations: {
      notes: {
        required: {},
      },
      initials: {
        required: {},
        pattern: {
          value: "",
          message: "Please fill initails.",
        },
      },
      fullName: {
        pattern: {
          value: /^[A-Za-z]+$/,
          message: "Please enter alphabets only.",
        },
        required: {},
      },
      beginnerCount: {
        pattern: {
          value: /^[0-9]*$/,
          message: "Please enter numeric value only.",
        },
        required: {},
      },
    },
  });

  const reqBookHandler = (e) => {
    e.preventDefault();
    if (!terms) {
      setError(true);
      //  return
    }
    const instructionDetail = {
      _id: cartItemData.id,
      beginnerCount: values.beginnerCount,
      notes: values.notes,
      accept: terms,
      isSubmitted: true,
      initials: values.initials,
      fullName: values.fullName,
    };

    if (localStorage.getItem("_modaldetails")) {
      const localData = JSON.parse(localStorage.getItem("_modaldetails"));
      const newData = localData.filter((item) => cartItemData.id !== item._id);

      localStorage.setItem(
        "_modaldetails",
        JSON.stringify([...newData, instructionDetail])
      );
    } else {
      localStorage.setItem(
        "_modaldetails",
        JSON.stringify([instructionDetail])
      );
    }

    closeModal(false);
    if (!terms) {
      setError(false);
      return;
    }
  };

  // hidden scrolling when open Any special instructions modal section start

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("_modaldetails"))?.find(
      (item) => cartItemData.id == item._id
    );
    data && setInitialValues(data);
    document.querySelector("body").classList.add("hidden_modal_body");

    return function () {
      document.querySelector("body").classList.remove("hidden_modal_body");
    };
  }, []);

  // hidden scrolling when open Any special instructions modal section end
  // const saveData = () => {
  //   if (localStorage.getItem("_modaldetails")) {
  //     const localData = JSON.parse(localStorage.getItem("_modaldetails"));
  //     const newData = localData.map((item) => item.fullName);
  //     if (newData === null || newData.initials === null) {
  //       console.log(newData === null || newData.initials === null);
  //       alert("flkdfhg");
  //     }
  //   }
  // };
  // console.log("cartItemData?.heightMax", cartItemData);
  return (
    <>
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />

      <div className="modalbg">
        <div className="modalbg_inner">
          <div className="special_instructions_modal position-relative">
            <button className="remove_modal" onClick={() => closeModal(false)}>
              <svg width="25" height="25" viewBox="0 0 25 25">
                <defs></defs>
                <g transform="translate(-680 -168)">
                  <circle
                    style={{ fill: "#4E74F6" }}
                    cx="12.5"
                    cy="12.5"
                    r="12.5"
                    transform="translate(680 168)"
                  />
                  <g transform="translate(687.243 156.151) rotate(45)">
                    <path
                      style={{
                        fill: "none",
                        stroke: "#fff",
                        strokeLinecap: "square",
                        strokeWidth: "1.3px",
                      }}
                      d="M27,11H14"
                      transform="translate(0 2.5)"
                    />
                    <path
                      style={{
                        fill: "none",
                        stroke: "#fff",
                        strokeLinecap: "square",
                        strokeWidth: "1.3px",
                      }}
                      d="M18,7V20"
                      transform="translate(2.5 0)"
                    />
                  </g>
                </g>
              </svg>
            </button>

            <form
              className="special_instruction_from"
              onSubmit={reqBookHandler}
            >
              <div className="heading_top">
                <h3 className="everyday_color">Special Instructions</h3>
              </div>
              <p className="special_insturct_heading">
                PelaGo wants to serve you better. Please describe any special
                instructions you may have pertaining to your reservation.
              </p>
              {/* <div className="min_max_section">
                <span>Note:</span>
                <p className="mb-0">
                  Minimum number of participants per booking: 
                </p>
                <p>
                  {" "}
                  Maximum number of participants per booking: {cartItemData.max}
                </p>
              </div> */}

              <div className="mt-4 mb-4">
                <p className="special_insturct_heading">
                  Number of persons
                  <p className="special_height mt-3">
                    <p className="mb-0 special_height_text">
                      Min Number: {cartItemData.min}
                    </p>
                    <p className="mb-0 special_height_text">
                      Max Number: {cartItemData.max}
                    </p>
                  </p>
                </p>
              </div>

              {cartItemData?.heightmax !== "" &&
              cartItemData?.heightmin !== "" ? (
                <div className="mt-4 mb-4">
                  <p className="special_insturct_heading">
                    There is minimum & maximum height for this excursion listed
                    below(inches)
                    <p className="special_height mt-3">
                      <p className="mb-0 special_height_text">
                        Min Height: {cartItemData?.heightmin}'
                      </p>
                      <p className="mb-0 special_height_text">
                        Max Height: {cartItemData?.heightmax}"
                      </p>
                    </p>
                  </p>
                </div>
              ) : (
                ""
              )}

              {cartItemData.weightmax !== "" &&
              cartItemData.weightmin !== "" ? (
                <div className="mt-4 mb-4">
                  <p className="special_insturct_heading">
                    There is minimum & maximum weight for this excursion listed
                    below(Pounds)
                    <p className="special_height mt-3">
                      <p className="mb-0 special_height_text">
                        Min Weight: {cartItemData?.weightmin} LBS{" "}
                      </p>
                      <p className="mb-0 special_height_text">
                        Max Weight: {cartItemData?.weightmax} LBS
                      </p>
                    </p>
                  </p>
                </div>
              ) : (
                ""
              )}

              <div className="radio_input_field">
                <label htmlFor="#" className="special_lable">
                  Do you have any special needs, instructions, or requests for
                  your booking?
                </label>
                <div className="radio_select d-flex">
                  <div className="radio_yes">
                    <input
                      type="radio"
                      name="radio"
                      value="yes"
                      id="yes"
                      className="radio_yes_no"
                      onChange={(e) => setshowTextbox(e.target.value)}
                      checked={showTextbox === "yes"}
                    />
                    <label htmlFor="yes" className="vv_color radio_lable_color">
                      Yes
                    </label>
                  </div>
                  <div className="radio_no">
                    <input
                      type="radio"
                      name="radio"
                      value="no"
                      id="no"
                      className="radio_yes_no"
                      onChange={(e) => setshowTextbox(e.target.value)}
                      checked={showTextbox === "no"}
                    />
                    <label htmlFor="no" className="radio_lable_color">
                      No
                    </label>
                  </div>
                </div>
                {showTextbox === "yes" ? (
                  <div className="input_field">
                    <textarea
                      name="notes"
                      id="notes"
                      {...bindField("notes")}
                      className="text_aria"
                      placeholder="Enter Text"
                      required
                    ></textarea>
                    {errors.notes && (
                      <p className="text-danger">{errors.notes}</p>
                    )}
                  </div>
                ) : null}
              </div>
              {/* <div className="input_field mt-3">
                <label htmlFor="#" className="special_lable">
                  How many beginner level participants are in this reservation?
                </label>
                <input
                  type="text"
                  placeholder="Enter Number"
                  {...bindField("beginnerCount")}
                  required
                />
                {errors.beginnerCount && (
                  <p className="text-danger">{errors.beginnerCount}</p>
                )}
              </div> */}
              {/* <div className="persons_container">
              <h5 className="ml-0 persons_heading special_lable">
                Number of persons
              </h5>
              <div className="person_min_max_box d-flex">
                <div className="input_field_min">
                  <label htmlFor="min_person" className="vv_color minmaxlable">
                    Min Person:
                  </label>
                  <p className="person">{cartItemData?.min}</p>
                </div>
                <div className="input_field_max">
                  <label htmlFor="max_person" className="vv_color minmaxlable">
                    Max Person:
                  </label>
                  <p className="person">{cartItemData?.max}</p>
                </div>
              </div>
            </div> */}



              {cartItemData?.liability && (
                <div className="laibility_docs mb-5 mt-3">
                  <label htmlFor="max_person" className="vv_color minmaxlable mb-0">
                    Documents :
                  </label>
                  <div className="d-flex align-items-center">
                  <img src={docsImg} alt="docs" className="docs_pdf_img" />
                 <p className="pdf_text">
                 {cardData.filter(
                              (cd) => cd._id === cartItemData.id
                            )[0].excursion.liabilityDoc[0]
                          }
                  </p> 
                    <button
                      className="view_btn"
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_MEDIA_URL}${
                            cardData.filter(
                              (cd) => cd._id === cartItemData.id
                            )[0].excursion.liabilityDoc[0]
                          }`
                        )
                      }
                    >
                      
                      View
                    </button>
                  </div>

                  <div
                    className="terms_conditon d-flex mt-2 mb-3"
                    // onClick={passwordModal}
                  >
                    <label className="control mb-0">
                      <input type="checkbox" id="terms" required />

                      <span className="checkmark"></span>
                    </label>
                    <span onClick={() => setPasswordModal(true)}>
                      <span className="alltermcond_text curser">
                        I Accept All Terms &amp; Conditions
                      </span>
                      <span className="text-intial">
                        {" "}
                        Click Here ! To Fill The Initials
                      </span>
                    </span>
                  </div>
                  {showError ? (
                    <span className="text-danger">
                      Please Accept All Terms &amp; Conditions
                    </span>
                  ) : null}
                </div>
              )}

              <div className="special_inst_sub">
                <button
                  type="submit"
                  className="special_inst_save active blue-bg"
                  // onClick={saveData}
                  // onClick={(e)=>{reqBookHandler(e);
                  //  selectTimeslot(e)
                  // }}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <InitialModal
        cartDetails={cartDetails}
        show={passwordModal}
        setPasswordModal={setPasswordModal}
        bindField={bindField}
        values={values}
        errors={errors}
        setInitialValues={setInitialValues}
      />

      {/* <ToastContainer /> */}
    </>
  );
}

export default SpecialInstrucModal;
